module.exports = __webpack_public_path__ + "static/media/codequest3.0.66ff2ba3.jpg";